import { IconButton } from "@mui/material";

import type { SxProps, Theme } from "@mui/material";
import type { FC, ReactNode } from "react";

export const EditorButton: FC<{
  "data-analytics-button": string;
  onClick?: () => void;
  icon: ReactNode;
  sx?: SxProps<Theme>;
}> = (props) => {
  const { onClick: handleClick, icon, sx, ...rest } = props;
  return (
    <IconButton
      data-analytics-id={props["data-analytics-button"]}
      {...rest}
      sx={{
        backgroundColor: "background.contrast",
        ":hover": {
          bgcolor: "background.active",
        },
        ...sx,
      }}
      size="small"
      onClick={handleClick}
    >
      {icon}
    </IconButton>
  );
};
